import React from "react";
import { useLanguage } from "../../../../contexts";
import { ASPECT_COLOR, mixHex } from "./visualColors";

// Mapa de ruta en "hitos por año": una columna por año del horizonte, con
// las metas que inician (▸) y los objetivos que vencen (◆) ese año. Puerto
// de renderRoadHitos() del mockup de referencia — es el único diseño de
// mapa de ruta que no usa la grilla de años compartida (arma su propio
// grid, una columna = un año).
export function RoadmapMilestones({ groups, baseYear, horizonEnd }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const years = Array.from({ length: horizonEnd - baseYear + 1 }, (_, i) => baseYear + i);

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: `repeat(${years.length},1fr)`, gap: 8, maxWidth: 900, margin: "0 auto" }}>
        {years.map((y) => {
          const inician = [];
          const vencen = [];
          groups.forEach(({ aspect, objetivos }) => {
            const color = ASPECT_COLOR[aspect] || "#5E89B4";
            objetivos.forEach((o) => {
              if (o.year === y) vencen.push({ text: `${o.code || "—"} −${o.reductionTons}% ${o.source}`, color });
              (o.metas || []).forEach((m) => {
                if (Number(String(m.fechaInicio).slice(0, 4)) === y) {
                  inician.push({ text: `${m.code} ${m.description.length > 42 ? `${m.description.slice(0, 42)}…` : m.description}`, color });
                }
              });
            });
          });
          return (
            <div key={y} style={{ pageBreakInside: "avoid" }}>
              <div style={{ background: "#1A3562", color: "#fff", textAlign: "center", borderRadius: "8px 8px 0 0", padding: 6, fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 12.5 }}>
                {y}
              </div>
              <div style={{ border: "1px solid #D4E5F0", borderTop: "none", borderRadius: "0 0 8px 8px", padding: 7, minHeight: 70 }}>
                {inician.map((x, i) => (
                  <div key={`i${i}`} style={{ fontSize: 9.5, color: "#1A3562", borderLeft: `3px solid ${x.color}`, padding: "3px 5px", marginBottom: 4, background: "#F8FBFD", borderRadius: "0 5px 5px 0" }}>
                    ▸ {x.text}
                  </div>
                ))}
                {vencen.map((x, i) => (
                  <div key={`v${i}`} style={{ fontSize: 9.5, fontWeight: 700, color: x.color, borderLeft: `3px solid ${x.color}`, padding: "3px 5px", marginBottom: 4, background: mixHex(x.color, 0.92), borderRadius: "0 5px 5px 0" }}>
                    ◆ {t("pd_hitos_meta_label")} {x.text}
                  </div>
                ))}
                {!inician.length && !vencen.length && (
                  <div style={{ fontSize: 9.5, color: "#C4CFDA", textAlign: "center", paddingTop: 16 }}>—</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div style={{ textAlign: "center", marginTop: 10, fontSize: 10, color: "#6B7A8E" }}>{t("pd_hitos_legend")}</div>
    </div>
  );
}
